<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <introduction
      v-show="step == 'introduction'"
      endpoint="demande-enquete"
      :estFormulairePublic="estFormulairePublic"
      @next-step="next"
    >
    </introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#2e4a62" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import IdentificationDemandeur from "@/components/DemandeEnquete/IdentificationDemandeur.vue"
import IdentificationPsychologue from "@/components/DemandeEnquete/IdentificationPsychologue.vue"
import IdentificationClients from "@/components/DemandeEnquete/IdentificationClients.vue"
import ObjetPlainte from "@/components/DemandeEnquete/ObjetPlainte.vue"
import Consentement from "@/components/DemandeEnquete/Consentement.vue"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/demande-enquete/",
      paramsName: "formulaire_demandeenquete",
      estFormulairePublic: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identificationDemandeur", code: "titre-etape-1", state: "" },
        { path: "identificationPsychologue", code: "titre-etape-2", state: "" },
        { path: "identificationClients", code: "titre-etape-3", state: "" },
        { path: "objetPlainte", code: "titre-etape-4", state: "" },
        { path: "consentement", code: "titre-etape-5", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    IdentificationDemandeur,
    IdentificationPsychologue,
    IdentificationClients,
    ObjetPlainte,
    Consentement,
    Soumission
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>